// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"551":"2a55f990","869":"c06001b5"}[chunkId] + ".chunk.css";
};